document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.hris-switcher > button');
  const containers = document.querySelectorAll('.hris-container');

  [...buttons].forEach(button => {
    button.addEventListener('click', () => {
      [...buttons].forEach(btn => btn.classList.remove('active-icon'));
      button.classList.add('active-icon');
      containers.forEach(container =>
        container.classList.remove('hris-visible')
      );
      const target = document.querySelector(
        `.${button.getAttribute('data-target')}`
      );
      target.classList.add('hris-visible');
    });
  });
});
